import { useParams } from "@tanstack/react-router";
import { AppIcon, Plate } from "@wilco/ui";
import { NotFound } from "./ErrorPages.tsx";
import { t } from "./i18n.ts";
import { findSection } from "./shell/sections.ts";

/** Раздел без модуля: место под его экраны. */
export function SectionPage() {
  const { sectionId } = useParams({ from: "/app/s/$sectionId" });
  const section = findSection(sectionId);
  if (!section) return <NotFound />;
  return (
    <div className="page">
      <h1 className="page-title page-title-icon">
        <AppIcon name={section.icon} size={32} />
        {t(section.label)}
      </h1>
      <Plate cut="md" className="w-fade-in">
        <p className="w-muted">{t("section.placeholder")}</p>
      </Plate>
    </div>
  );
}
